import { Injectable } from '@angular/core';

import { UserService } from './services';
import { MsalService } from './services/msal.service';

@Injectable({
  providedIn: 'root'
})
export class SessionIdResolverService  {

  isSessionOnProgress = false;

  constructor(private authService: UserService, private msalService: MsalService) { }

  /**
   * This resolver causes the first application module not to be loaded until the resolve() is completed.
   * The first time you log in, call the API to get the SessionID
   * and be able to navigate the dashboard,
   * while all other times it gives you access to the application
   */


    async resolve(): Promise<void> {
      //console.log("Resolving Session ID")
    if (!localStorage.getItem('SessionID')) {
      if (!this.isSessionOnProgress) {
        this.isSessionOnProgress = true;
        try {
          await this.authService.getSessionID();
        } catch (error) {
          this.msalService.logout();
        } finally {
          this.isSessionOnProgress = false;
        }
      } else {
        return new Promise((resolve) => {
          const interval = setInterval(() => {
            if (localStorage.getItem('SessionID')) {
              clearInterval(interval);
              resolve();
            }
          }, 10000);
        });
      }
    }
  }
}
